<template>
  <div>
  <div v-if="modalExists"
          class="fixed z-50 inset-0 overflow-y-auto backdrop-blur-sm"
          >
    <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;
      <!--
        Modal panel, show/hide based on modal state.

        Entering: "ease-out duration-300"
          From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100 translate-y-0 sm:scale-100"
          To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      -->
      <transition
          enter-active-class="ease-out duration-300"
          enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-active-class="ease-in duration-200"
          leave-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
        <div v-show="isOpen"
            class="inline-block border border-gray-200 align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden
                            shadow-xl transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6"
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal-headline"
                @click.stop="">
          <div>
            <div class="inline-flex justify-between w-full">
            <div class="p-2 text-base flex">
              <button v-if="!processing" @click="clickReset" class="font-bold text-blue-600 hover:text-blue-500">
                Reset Pin
              </button>
              <span v-else class="lnr icon-loading animate-spin" style="font-size: 1.2rem;"></span>
            </div>
            <button @click="clickCancel" type="button" class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-offset-2">
              <span class="sr-only">Close</span>
              <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
              </div>
            <div class="mt-8 text-center">
              <h4 class="text-lg leading-6 font-semibold text-gray-900" id="modal-headline">
                <span>Please Authenticate</span>
              </h4>
              <span class="text-base font-medium text-gray-700">{{ bodyText }}</span>
              <div class="mt-4 flex text-left justify-center">
                  <floating-input     v-model:value="_pin"
                                      label="Confirmation Pin"
                                      id="user_pin"
                                      class="w-3/5 text-left"
                                      :class="[incorrectPin ? 'border border-red-500' : 'border-0']"
                                      @change="textChange"
                  ></floating-input>
              </div>
              <div class="pt-4">
                <label for="comment" class="block text-sm font-medium text-gray-700 text-left">Add or update your notes to be recorded on the confirmation event</label>
                <div class="mt-1">
                  <textarea v-model="_notesText" rows="4" name="comment" id="comment" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"></textarea>
                </div>
              </div>
            </div>
          <div class="mt-2 sm:mt-6">
            <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                            <span v-if="notesEmpty" class="flex w-full rounded-md shadow-sm2 col-span-2">
                                <button type="button"
                                        disabled
                                        class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-gray-400 text-base leading-6 font-medium text-white shadow-sm sm:text-sm sm:leading-5">
                                    <slot name="button-primary-content">
                                        Notes Required
                                    </slot>
                                </button>
                            </span>
                            <span v-else class="flex w-full rounded-md shadow-sm2 col-span-2">
                                <button type="button"
                                        @click="clickProceed"
                                        class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-blue-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:border-blue-700 focus:ring-blue-200 sm:text-sm sm:leading-5">
                                    <slot v-if="!processing"     name="button-primary-content">
                                        Submit
                                    </slot>
                                  <slot v-else name="button-primary-processing">
                                    <span class="lnr icon-loading animate-spin" style="font-size: 1.2rem;"></span>
                                  </slot>
                                </button>
                            </span>
            </div>
          </div>
        </div>
        </div>

      </transition>

    </div>
  </div>
  <!-- v-if="cfrCheckComplete" hides the action slot until the cfr Strict check is complete.  -->
    <div v-if="!cfrCheckComplete"
         class="inline-flex w-full justify-center">
      <span class="lnr icon-loading animate-spin py-4" style="font-size: 1.2rem;"></span>
    </div>
  <slot v-else name="submitAction" :onSubmit="onSubmit"></slot>
  </div>



</template>

<script>

import axios from "axios";
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {UrlParamsMixin} from "@/mixins/UrlParamsMixin";
import {iconNamesMixin} from "@/mixins/IconNamesMixin";
import { v4 as uuidv4 } from 'uuid';
import FloatingInput from "@/components/elements/FloatingInput";
const CLOSE_DELAY = 200

export default {
  name: "ConfirmationModal",
  mixins: [SonicuCoreMixin, iconNamesMixin, UrlParamsMixin],
  components: {FloatingInput},
  emits: ['update:isOpen', 'close', 'action', 'primary-action', 'secondary-action', 'authenticated',
    'authentication-success', 'strict-cfr-disabled', 'authentication-failure'],
  props: {
    notesText: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      _pin: '',
      modalExists: this.isOpen,
      bodyText: 'Please enter your pin and press "Submit" to continue.  If you do not remember your pin, please select "Reset Pin" to have a new pin sent to your email address.',
      isOpen: false,
      cfrEnabled: false,
      processing: false,
      confirmationRequestUuid: uuidv4(),
      cfrCheckComplete: false,
      incorrectPin: false,
      _notesText: this.notesText,
      notesEmpty: true,
    }
  },
  mounted() {
    axios.get(this.company.buildCompanyApiInternalRoute('confirmation-company-status')).then(response => {
        if(response['data']['strict_confirmation_active'] === true){
          if(!response['data']['user_pin_set']){
            axios.put(this.company.buildCompanyApiInternalRoute(`user-pin/reset`),
            ).then(response => {
              this.processing = false;
              console.log(response);
              this.bodyText = 'This is your first time performing a confirmed action.  A confirmation pin has been sent to your email.  Please enter the pin below and press "Submit" to continue.  If you do not receive the email in the next 5 minutes, please select "Reset Pin" to have a new pin sent to your email address.';
            }).catch(error => {
              this.processing = false;
              this.bodyText = 'Error occurred while attempting to set your intitial pin, please contact support.';
              console.log(error)
            });
          }
          this.cfrEnabled = true;
        }
      this.cfrCheckComplete = true;

    });
  },
  methods: {
    close() {
      console.log('close');
      this.isOpen = false;
      // Adding the close event on modal close.
      this.$emit('close');
    },
    clickProceed(){
      this.processing = true;
      var data = {};
      data['confirmation_request_uuid'] = this.confirmationRequestUuid;
      data['user_pin'] = this._pin;
      data['notes'] = this._notesText;
      axios.post(this.company.buildCompanyApiInternalRoute(`confirmation/`),
          data,
      ).then(response => {
        this.processing = false;
console.log(response);
        if(response['data']['success']){
          console.log('success');
          console.log(this.confirmationRequestUuid);
          this.$emit('authentication-success', this.confirmationRequestUuid);
          this.bodyText = 'Authentication Successful';
          this.close()
        }
        else{
          this.processing = false;
          this.incorrectPin = true;
          this.bodyText = 'Incorrect pin.  Please try again. or select "Reset Pin" to have a new pin sent to your email address.';
          this.$emit('authentication-failure')
        }

      }).catch(error => {
        this.processing = false;
        this.bodyText = 'Error occurred while authenticating.  Please try again. If the problem persists, please contact support.';
        console.log(error)
      });

    },
    clickCancel(){
      console.log('cancel');
      this.$emit('action', false);
      this.$emit('secondary-action')
      this.close();
    },
    clickReset(){
      this.processing = true;
      axios.put(this.company.buildCompanyApiInternalRoute(`user-pin/reset`),
      ).then(response => {
        this.processing = false;
        this.bodyText = "A new pin has been sent to your email address.  Please check your email and enter the new pin below.";

      }).catch(error => {
        this.processing = false;
        this.bodyText = 'Error occurred while resetting pin.  Please try again. If the problem persists, please contact support.';
        console.log(error)
      });
    },
    onSubmit() {
      if(!this.cfrEnabled){
        this.$emit('strict-cfr-disabled');
      }
      else{
        this.isOpen = true;
      }
    },
    onHover(){
      console.log('hover');
    },
    textChange(){
      this.incorrectPin = false;
    },
  },
  watch: {
    isOpen() {
      console.log('isOpen changed');
      setTimeout(() => {
        this.modalExists = this.isOpen
      }, CLOSE_DELAY)
    },
    notesText() {
      this._notesText = this.notesText;
    },
    _notesText(){
      console.log('notesText changed');
      this.notesEmpty = this._notesText === '';
    }
  },
  computed: {

  },
}

</script>

<style scoped>

</style>